<template>
    <div class="entity-form" @click="(e)=>{e.stopPropagation()}">
        <form @submit.prevent="(e)=>{e.stopPropagation()}">
            <div class="form-heading">
                <div  class="form-title">{{$t('form.focusproduct.heading')}}</div>


                <button :aria-disabled="hostPerson === -1" class="button-primary button-primary__oraange button-primary__thin" @click="cancelForm" >{{$t('form.participant.done')}}</button>
            </div>

            <div class="flex-column" style="margin-top: 16px; padding: 6px;">
                <div><CategoryList mode="focuslist" :party="party"
                                   @add-focus-product="addFocusProduct"
                                   @remove-focus-product="removeFocusProduct"
                />
                </div>
            </div>
         </form>
    </div>
</template>

<script>
    import CategoryList from "../lists/CategoryList"
    import {mapGetters}  from  'vuex'
    export default {
        name: "FocusProductForm",
        components: {CategoryList},
        data() {
          return {
              filtered:'',
              partyId:-1,
              line_type:1,
              custlist:null
          }
        },

        props: {
            reference: {
                type: [ Number],
                default:-1
            },
            for_linetype: {
                type: [ Number],
                default:1
            }
        },
        computed:{
            ...mapGetters(['getDealerParty','getActiveParty','dealer']),
            party(){
                return this.getActiveParty ?? null
            },
        },

        mounted(){
            if(this.reference > 0){
                this.partyId = this.reference
            }
            this.party = this.$store.getters.activeParty
        },
        methods: {
            cancelForm(){
                this.$emit('form-closed')
               // this.$router.go({name: 'Party', params: {id: this.reference}})
            },
            removeFromCartClicked(custId, sku){
                this.$store.dispatch('removeProductFromWoc',{personId:custId, sku:sku,line_type:this.for_linetype}).then(()=>{
                    this.$store.dispatch('getCustomerOrderlist', this.reference).then((res)=>{
                        console.log(res)
                        this.$store.dispatch('loadParty', res.partyId).then(()=>{

                        })
                        this.custlist = res

                        this.$store.dispatch('loadOpenOrder' ).then((res)=>{
                            this.emitter.emit('custlist_updated',res)

                        })


                    }).catch(()=>{

                    })
                })
            },
            addFocusProduct(sku, price){
                this.$store.dispatch('addFocusProduct',{partyId:this.party.id, sku:sku, price:price}).then(()=>{
                    this.$store.dispatch('loadParty', this.party.id).then(()=>{
                        this.party = this.$store.getters.activeParty
                        this.emitter.emit('party_updated',this.party)
                    })
                })
            },
            removeFocusProduct(sku){
                this.$store.dispatch('removeFocusProduct',{partyId:this.party.id, sku:sku}).then(()=>{
                    this.$store.dispatch('loadParty', this.party.id).then(()=>{
                        this.party = this.$store.getters.activeParty
                        this.emitter.emit('party_updated',this.party)
                    })
                })
            },
        }
    }
</script>

<style scoped>

</style>
